<template lang="">
  <section>
    <MyNavBar :theme="theme" />
  </section>
  <section><RegisterCard /></section>
  <section><MyAbout /></section>
  <MyFooter />
</template>

<script>
import MyNavBar from "@/components/MyNavBar.vue";
import RegisterCard from "@/components/RegisterCard.vue";
import MyFooter from "@/components/MyFooter.vue";
export default {
  components: {
    MyNavBar,
    // eslint-disable-next-line vue/no-unused-components
    RegisterCard,
    MyFooter,
  },
  data() {
    return {
      theme: "light",
    };
  },
};
</script>

<style lang=""></style>
